import debounce from 'lodash/debounce';
// default options to debounce button clicks
export default function defaultDebounce(
  callback,
  customBounceTime,
  options = { leading: true, trailing: false },
) {
  return debounce(callback, customBounceTime || 500, options);
}
